import styles from '../../assets/styles/CountDown/CountDown.module.scss';
import React from "react";
import { MimaButton, MimaText } from "..";
import { userStore } from '../../stores';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';

const AppDLBanner = ({ appLink, setAppLink, hasMobileApp }) => {

    const appleIcon = <img src={AppleStoreIcon} alt='Mima Business on ios' className={styles.banner__icon} />;

    const playIcon = <img src={PlayStoreIcon} alt='Mima Business on android' className={styles.banner__icon} />;

    return (
        <>
            {((appLink && !hasMobileApp) || !hasMobileApp) && (
                <div className={styles.banner}>
                    <MimaText
                        variant="small"
                        mb={2}
                        mt={1}
                    >
                        Download and use the Mima business app on your mobile devices.
                    </MimaText>
                    <div className={styles.banner__beside}>
                        <a href='https://play.google.com/store/apps/details?id=com.mima.mima' style={{ textDecoration: "none" }}>
                            <MimaButton
                                title="Get app on Android"
                                variant="outlined3"
                                icon={playIcon}
                                mb={1}
                            />
                        </a>

                        <a href='https://apps.apple.com/us/app/mima-business/id6444887331' style={{ textDecoration: "none" }}>
                            <MimaButton
                                title="Get app on iPhone"
                                variant="outlined3"
                                icon={appleIcon}
                                mb={1}
                            />
                        </a>
                    </div>

                    <MimaButton
                        title="Close"
                        variant="colorableSmall"
                        buttonColor="var(--color-error)"
                        onClick={() => {
                            setAppLink(false);
                            userStore.setHasMobileApp(true);
                        }}
                        mb={1}
                    />
                </div>
            )}
        </>
    )
}
export default AppDLBanner;